<div class="cart-list-item" (click)="onEdit()">
    <p *ngIf="item.version_code > 0 && item.state !== undefined && OrderStateData[item.state] as state" class="mb-1">
        <tui-tag size="s" [value]="state.label | transloco" [class]="state.className" status="custom"></tui-tag>
    </p>
    <div class="flex items-start justify-between mb-1 gap-2">
        <span class="font-medium text-sm block">
            <span>
                <ng-container *ngIf="readonly || item.version_code > 0">
                    <span>{{ item.quantity + ' x ' }}</span>
                </ng-container>
                {{ item.product_name }}&nbsp;
                <span class="font-normal text-gray-600"> ({{ item.unit.name }}) </span>
            </span>
        </span>

        <span class="text-right font-medium text-sm block flex-none">
            {{ item.price * item.quantity | formatCurrency }}
        </span>
    </div>

    <ng-container *ngIf="item.options?.length || 0 > 0">
        <ul class="list-disc list-inside font-normal text-sm text-gray-500 mb-1">
            <li *ngFor="let option of item.options">
                {{ option.name }}
            </li>
        </ul>
    </ng-container>

    <ng-container *ngIf="item.combo?.length || 0 > 0">
        <ul class="list-disc list-inside font-normal text-sm text-gray-500 mb-1">
            <li *ngFor="let comboItem of item.combo">
                {{ comboItem.product_name }}
            </li>
        </ul>
    </ng-container>

    <ng-container *ngIf="item.note !== '' && item.note !== null">
        <p class="font-normal text-xs text-gray-500 text-ellipsis overflow-hidden mb-1">
            {{ 'note' | transloco }} : {{ item.note }}
        </p>
    </ng-container>
    <ng-container *ngIf="!readonly && item.version_code === 0">
        <div class="flex items-end justify-between">
            <span>
                <a
                    class="font-semibold text-red-400 hover:text-red-500 text-xs w-max mt-1 cursor-pointer mr-2"
                    (click)="onDeleteItem($event)"
                >
                    {{ 'delete' | transloco }}
                </a>
                <!-- <a
                    class="font-semibold text-orange-400 hover:text-orange-500 text-xs w-max mt-1 cursor-pointer mr-2"
                    (click)="onEdit()"
                >
                    {{ 'edit' | transloco }}
                </a> -->
            </span>

            <us-number-group
                [value]="item.quantity"
                (decreaseQuantityClick)="onChangeItemQuantity(item.quantity - 1)"
                (increaseQuantityClick)="onChangeItemQuantity(item.quantity + 1)"
                [minimumQuantity]="1"
                [maximumQuantity]="maximumQuantity"
                class="min-w-max w-28"
            >
            </us-number-group>
        </div>
    </ng-container>
</div>
